import { render } from "./tab-familiar-background.vue?vue&type=template&id=2e549c7c&scoped=true"
import script from "./tab-familiar-background.vue?vue&type=script&lang=js"
export * from "./tab-familiar-background.vue?vue&type=script&lang=js"

import "./tab-familiar-background.vue?vue&type=style&index=0&id=2e549c7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e549c7c"]])

export default __exports__